import {getOtsThemeVariables, type OtsColorScheme} from "../theme/otsThemeTokens";

/** Glide supplies white as the selected sprite background; use the matching on-primary ink. */
export function getDataGridSortIcons(scheme: OtsColorScheme = "light") {
  const selectedInk = getOtsThemeVariables("corporate", scheme)["--ots-on-primary"];
  const icon =
    (path: string) =>
    ({bgColor}: {bgColor: string}) =>
      `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path d="${path}" fill="none" stroke="${
        bgColor === "white" ? selectedInk : bgColor
      }" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
  return {
    "ots-sort-asc": icon("M10 16V4m-5 5 5-5 5 5"),
    "ots-sort-desc": icon("M10 4v12m-5-5 5 5 5-5"),
  };
}
